import auth from "../../middlewares/auth";

export const companyRoutes = [
    {
        path: '/companies',
        component: () => import(/* webpackChunkName: "companies" */ '../../views/companies/Company'),
        name: 'companies',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['company-manage']
        }
    },
    {
        path: '/company/:id',
        component: () => import(/* webpackChunkName: "companies" */ '../../views/companies/CompanyForm'),
        name: 'update-company',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['company-manage']
        }
    },
    {
        path: '/create-company',
        component: () => import(/* webpackChunkName: "companies" */ '../../views/companies/CompanyForm'),
        name: 'create-company',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['company-manage']
        }
    },
    {
        path: '/company/:id/show',
        component: () => import(/* webpackChunkName: "companies" */ '../../views/companies/ViewCompany'),
        name: 'view-company',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['company-manage']
        }
    },
]